import { Controller } from "@hotwired/stimulus"

// Opens supported external destinations through iOS when the native handler is
// available. Older app builds and ordinary browsers fall back to the anchor's
// normal navigation instead of swallowing the tap.
export default class extends Controller {
  open(event) {
    const handler = window.webkit?.messageHandlers?.nativeExternalURL
    if (!handler) return

    event.preventDefault()
    handler.postMessage(this.element.href)
  }
}
